"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require("glamor");

var _semanticWebflow = require("@bodhi-project/semantic-webflow");

var _Image = require("@bodhi-project/components/lib/Image");

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ @bodhi-project/components


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop
var blockStyle = (0, _glamor.css)({
  padding: "14.625vh 0vh",

  "& .boe-lead": {},

  "& .boe-follow": {
    display: "flex",

    "& .boe-block": {
      flexGrow: 33,
      flexBasis: 0,
      margin: "0em 1em",
      boxShadow: "0px 3px 5px 0px rgba(30,30,30,0.2)",

      "& .boe-block-figure": {
        position: "relative",

        "& .boe-block-figure-image": {
          border: 0,
          background: "transparent"
        },

        "& .boe-block-figure-overlay": {
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          zIndex: 2
        }
      },

      "& .boe-block-text": {
        padding: "2.21em 1em",

        "& p": {
          marginBottom: 0
        },

        "& span": {
          fontSize: "77%"
        }
      },

      "&:nth-child(1)": {
        "& .boe-block-figure-overlay": {
          backgroundImage: "linear-gradient(to top, rgba(0, 198, 251, 0.5) 0%, rgba(0, 91, 234, 0.5) 100%)"
        }
      },

      "&:nth-child(2)": {
        "& .boe-block-figure-overlay": {
          backgroundImage: "linear-gradient(to top, rgba(112, 40, 228, 0.5) 0%, rgba(229, 178, 202, 0.5) 100%)"
        }
      },

      "&:nth-child(3)": {
        "& .boe-block-figure-overlay": {
          backgroundImage: "linear-gradient(120deg, rgba(212, 252, 121, 0.5) 0%, rgba(150, 230, 161, 0.5) 100%)"
        }
      }
    }
  }
});
var blockStyleClass = blockStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** Block */

var Block = function (_React$Component) {
  _inherits(Block, _React$Component);

  /** standard constructor */
  function Block(props) {
    _classCallCheck(this, Block);

    return _possibleConstructorReturn(this, _React$Component.call(this, props));
  }

  /** standard renderer */


  Block.prototype.render = function render() {
    var data = this.props.data;


    return _react2.default.createElement(
      _semanticWebflow.Section,
      { className: blockStyleClass },
      _react2.default.createElement(
        "div",
        { className: "boe-lead" },
        _react2.default.createElement(
          "h2",
          null,
          _react2.default.createElement(
            "span",
            null,
            data.lead.title
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "span",
            null,
            data.lead.text
          )
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "boe-follow" },
        _react2.default.createElement(
          "div",
          { className: "boe-block" },
          _react2.default.createElement(
            "div",
            { className: "boe-block-figure" },
            _react2.default.createElement(_Image2.default, {
              src: data.features[0].figure,
              rawWidth: 1440,
              rawHeight: 900,
              className: "boe-block-figure-image"
            }),
            _react2.default.createElement(
              "div",
              { className: "boe-block-figure-overlay" },
              "\xA0"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "boe-block-text" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "span",
                null,
                data.features[0].text
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "boe-block" },
          _react2.default.createElement(
            "div",
            { className: "boe-block-figure" },
            _react2.default.createElement(_Image2.default, {
              src: data.features[1].figure,
              rawWidth: 1440,
              rawHeight: 900,
              className: "boe-block-figure-image"
            }),
            _react2.default.createElement(
              "div",
              { className: "boe-block-figure-overlay" },
              "\xA0"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "boe-block-text" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "span",
                null,
                data.features[1].text
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "boe-block" },
          _react2.default.createElement(
            "div",
            { className: "boe-block-figure" },
            _react2.default.createElement(_Image2.default, {
              src: data.features[2].figure,
              rawWidth: 1440,
              rawHeight: 900,
              className: "boe-block-figure-image"
            }),
            _react2.default.createElement(
              "div",
              { className: "boe-block-figure-overlay" },
              "\xA0"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "boe-block-text" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "span",
                null,
                data.features[2].text
              )
            )
          )
        )
      )
    );
  };

  return Block;
}(_react2.default.Component);

Block.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

Block.defaultProps = {};

// --------------------------------------------------------------------- Export
exports.default = Block;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/blocks/lib/SectionBode.js
// module id = 428
// module chunks = 213534597649335